<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <!-- select -->
        <v-row>
          <v-col cols="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          </v-col>
          <v-col cols="6" class="v-margit_button text-right">
            <v-btn color="#1B437C" depressed dark @click="dialogSelect = true,showTabel = false">
              <v-icon left>mdi-text-box-plus</v-icon>
              เลือกประเภทที่จะส่ง
            </v-btn>
          </v-col>
        </v-row>
        <!-- select -->

        <!-- dialog -->
        <v-dialog v-model="dialogSelect" persistent max-width="40%">
          <v-card>
            <v-card-title class="text-h6">
              เลือกประเภทที่จะส่ง
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-row style="height: 65px">
                    <v-select
                      :items="selectItem"
                      v-model="selectData"
                      label="กรุณาเลือกแหล่งที่มาของข้อมูล"
                      dense
                      outlined
                      @change="selectDB()"
                    ></v-select>
                  </v-row>
                </v-col>
                <v-col cols="12" v-if="showTabel">
                  <v-card elevation="7" v-if="dataReady">
                    <v-card-title>
                      <v-text-field
                        v-model="searchAll2"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        dense
                        hide-details
                      ></v-text-field>
                    </v-card-title>
                    <v-card-text>
                      <v-data-table
                        :headers="columns"
                        :items="dataItem"
                        :search="searchAll2"
                        :items-per-page="10"
                        dense
                      >
                        <template v-slot:[`item.CREATE_DATE`]="{ item }">
                          {{ format_dateNotime(item.CREATE_DATE) }}
                        </template>
                        <template v-slot:[`item.LAST_DATE`]="{ item }">
                          {{ format_dateNotime(item.LAST_DATE) }}
                        </template>
                        <template v-slot:[`item.action`]="{ item }">
                          <v-btn
                            class="ma-2 btn-color"
                            small
                            dark
                            @click.stop="
                              ;(dialogSelect = false),
                                getDataById(item),
                                clearData()
                            "
                          >
                            เลือก
                            <!-- <v-icon dark> mdi-arrange-send-to-back </v-icon> -->
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                  <div v-if="!dataReady" class="text-center">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="btn1 btn-color"
                dark
                x-large
                @click=";(dialogSelect = false), tabel(), getDataList()"
              >
                <v-icon left> mdi-cancel</v-icon>
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- dialog -->

        <!-- broadcast -->
        <v-row v-if="dataSelect">
          <v-col cols="12">
            <v-container>
              <v-card class="mx-auto" elevation="2" outlined shaped>
                <v-container>
                  <v-card-title>
                    <span class="text-h6">บรอดแคสต์</span>
                  </v-card-title>
                  <v-card-text>
                    <v-form
                      ref="form_update"
                      v-model="validUpdate"
                      lazy-validation
                    >
                      <v-row>
                        <v-col cols="4" class="text-center">
                          <v-card elevation="2" class="mx-auto">
                            <v-container>
                              <v-card-title>เป้าหมายโดยประมาณ</v-card-title>
                              <v-card-text>
                                <v-progress-circular
                                  :rotate="360"
                                  :size="100"
                                  :width="15"
                                  :value="valueAdd"
                                  color="teal"
                                >
                                  {{ valueAdd }} %
                                </v-progress-circular>
                              </v-card-text>
                              <v-card-text>ประมาณ {{ dataAdd }} คน</v-card-text>
                            </v-container>
                          </v-card>
                          <!-- <br />
                          <v-card elevation="2" class="mx-auto">
                            <v-container>
                              <v-card-title>รายชื่อลูกค้า</v-card-title>
                              <v-card-text>
                                <v-list
                                  subheader
                                  dense
                                  style="max-height: 300px"
                                  class="overflow-y-auto"
                                >
                                  <v-list-item
                                    v-for="(item, index) in dataUserLine"
                                    :key="index"
                                  >
                                    <v-list-item-avatar>
                                      <v-img
                                        :alt="`${index} avatar`"
                                        :src="item.picture"
                                      ></v-img>
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="item__title"
                                        v-text="item.name"
                                      ></v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-divider inset></v-divider>
                                </v-list>
                              </v-card-text>
                            </v-container>
                          </v-card> -->
                        </v-col>
                        <v-col cols="8" class="text-center">
                          <v-row>
                            <v-col cols="12" class="text-center">
                              <v-img
                                aspect-ratio="6"
                                contain
                                :src="formUpdate.pictureUrl"
                              ></v-img>
                            </v-col>
                            <v-col cols="12">
                              <v-row style="height: 65px">
                                <v-select
                                  :items="dataAudience"
                                  v-model="selectAudience"
                                  label="เลือกกลุ่มเป้าหมาย"
                                  dense
                                  outlined
                                  required
                                  :rules="[rules.required]"
                                  @change="getDataAdd(item)"
                                ></v-select>
                              </v-row>
                            </v-col>
                            <v-col cols="12">
                              <v-row>
                                <v-textarea
                                  auto-grow
                                  rows="2"
                                  name="input-7-4"
                                  placeholder="ข้อความที่จะส่ง"
                                  label="ข้อความที่จะส่ง"
                                  counter
                                  dense
                                  outlined
                                  required
                                  v-model="formUpdate.titleText"
                                ></v-textarea>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      elevation="2"
                      x-large
                      color="success"
                      :disabled="!validUpdate"
                      :loading="loadingAdd"
                      @click="sendPush()"
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      ส่ง
                    </v-btn>
                  </v-card-actions>
                </v-container>
              </v-card>
            </v-container>
          </v-col>
        </v-row>

        <v-row v-if="dataSelectText">
          <v-col cols="12">
            <v-container>
              <v-card class="mx-auto" elevation="2" outlined shaped>
                <v-container>
                  <v-card-title>
                    <span class="text-h6">บรอดแคสต์</span>
                  </v-card-title>
                  <v-card-text>
                    <v-form
                      ref="form_update"
                      v-model="validUpdate"
                      lazy-validation
                    >
                      <v-row>
                        <v-col cols="4" class="text-center">
                          <v-card elevation="2" class="mx-auto">
                            <v-container>
                              <v-card-title>เป้าหมายโดยประมาณ</v-card-title>
                              <v-card-text>
                                <v-progress-circular
                                  :rotate="360"
                                  :size="100"
                                  :width="15"
                                  :value="valueAdd"
                                  color="teal"
                                >
                                  {{ valueAdd }} %
                                </v-progress-circular>
                              </v-card-text>
                              <v-card-text>ประมาณ {{ dataAdd }} คน</v-card-text>
                            </v-container>
                          </v-card>
                          <!-- <br />
                          <v-card elevation="2" class="mx-auto">
                            <v-container>
                              <v-card-title>รายชื่อลูกค้า</v-card-title>
                              <v-card-text>
                                <v-list
                                  subheader
                                  dense
                                  style="max-height: 300px"
                                  class="overflow-y-auto"
                                >
                                  <v-list-item
                                    v-for="(item, index) in dataUserLine"
                                    :key="index"
                                  >
                                    <v-list-item-avatar>
                                      <v-img
                                        :alt="`${index} avatar`"
                                        :src="item.picture"
                                      ></v-img>
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="item__title"
                                        v-text="item.name"
                                      ></v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-divider inset></v-divider>
                                </v-list>
                              </v-card-text>
                            </v-container>
                          </v-card> -->
                        </v-col>
                        <v-col cols="8" class="text-center">
                          <v-row>
                            <v-col cols="12" class="text-center">
                              <v-img
                                aspect-ratio="4"
                                contain
                                :src="formAdd.pictureUrl"
                                v-if="formAdd.pictureUrl"
                              ></v-img>
                              <br />
                              <v-file-input
                                required
                                counter
                                show-size
                                :rules="[rules.required]"
                                accept="image/png, image/jpeg, image/bmp"
                                prepend-icon="mdi-camera"
                                label="Image"
                                @change="selectImg"
                                v-model="filesAdd"
                              ></v-file-input>
                            </v-col>
                            <v-col cols="12">
                              <v-row style="height: 65px">
                                <v-select
                                  :items="dataAudience"
                                  v-model="selectAudience"
                                  label="เลือกกลุ่มเป้าหมาย"
                                  dense
                                  outlined
                                  required
                                  :rules="[rules.required]"
                                  @change="getDataAdd()"
                                ></v-select>
                              </v-row>
                            </v-col>
                            <v-col cols="12">
                              <v-row style="height: 65px">
                                <v-text-field
                                  v-model="formAdd.topic"
                                  :rules="[rules.required]"
                                  dense
                                  outlined
                                  label="หัวข้อ"
                                ></v-text-field>
                              </v-row>
                            </v-col>
                            <v-col cols="12" style="padding-bottom: 0;">
                              <v-row>
                                <v-textarea
                                  auto-grow
                                  rows="2"
                                  name="input-7-4"
                                  placeholder="ข้อความที่จะส่ง"
                                  label="ข้อความที่จะส่ง"
                                  dense
                                  outlined
                                  required
                                  :rules="[rules.required]"
                                  v-model="formAdd.content"
                                ></v-textarea>
                              </v-row>
                            </v-col>
                          </v-row>
                          <v-row >
                            <v-col cols="12" style="padding-top: 0;">
                              <v-btn
                                block
                                large
                                color="success"
                                :disabled="!validUpdate"
                                :loading="loadingAdd"
                                @click="sendPush()"
                              >
                                <v-icon left>mdi-checkbox-marked-circle</v-icon>
                                ส่ง
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text>
                  <!-- <v-card-actions>
                    <v-spacer></v-spacer>

                  </v-card-actions> -->
                </v-container>
              </v-card>
            </v-container>
          </v-col>
        </v-row>
        <!-- broadcast -->

        <!-- data table -->
        <!-- <v-col cols="12" v-if="!showTabel">
          <v-card elevation="7" v-if="dataReady">
            <v-card-title>
              <v-text-field
                v-model="searchAll2"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="columns"
                :items="dataItem"
                :search="searchAll2"
                :items-per-page="10"
              >
                <template v-slot:[`item.LAST_DATE`]="{ item }">
                  {{ format_dateNotime(item.LAST_DATE) }}
                </template>
                <template v-slot:[`item.blogExpiryDate`]="{ item }">
                  {{ format_dateNotime(item.blogExpiryDate) }}
                </template>
                <template v-slot:[`item.pictureUrl`]="{ item }">
                  <v-avatar color="primary" size="40">
                    <img :src="item.pictureUrl" alt="img"
                  /></v-avatar>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div v-if="!dataReady" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-col> -->
        <!-- end data table -->
      </div>
    </v-main>
  </div>
</template>
<style scoped>
.item__title {
  color: black !important;
  font-family: KittithadaBold !important;
  font-size: 20px !important;
}
</style>
<script>
import adminLeftMenu from '../Sidebar.vue' // เมนู
import VuetifyMoney from '../VuetifyMoney.vue'
import axios from 'axios' // api
// import moment from 'moment' // แปลง date
export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    VuetifyMoney
  },
  data () {
    return {
      e1: 1,
      valueAdd: 0,
      dataAdd: 0,
      searchAll2: '',
      dataReady: true,
      dataSelect: false,
      dataSelectText: false,
      returnLink: '/BroadCast/BroadCast',
      session: this.$session.getAll(),
      dialogSelect: false,
      showTabel: false,
      validUpdate: true,
      selectItem: ['ของรางวัล', 'กิจกรรม', 'ข้อความ'],
      selectData: '',
      selectAudience: '',
      rules: {
        required: value => !!value || 'กรุณากรอก.'
      },
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'บรอดแคสต์',
          disabled: false,
          href: '/BroadCast/BroadCast'
        }
      ],
      columns: [
        { text: 'รูป', value: 'pictureUrl' },
        { text: 'กลุ่มเป้าหมาย', value: 'audiencesName' },
        { text: 'ประเภท', value: 'module' },
        { text: 'วันอัพเดท', value: 'LAST_DATE' }
      ],
      dataItem: [],
      formUpdate: {},
      dataAudience: [],
      dataUserLine: [],
      idData: '',
      referId: '',
      path: '',
      //   loading
      startDate: '2022-08-01',
      //   new Date(new Date().getFullYear(), new Date().getMonth(), 2).toISOString().substr(0, 10),
      endDate: '2022-09-30',
      //   new Date(Date.now() - new Date().getTimezoneOffset() * 30000).toISOString().substr(0, 10),
      loadingAdd: false,
      Das: '',
      filterAudience: [],
      arr: [],
      formAdd: {
        topic: '',
        content: '',
        pictureUrl: ''
      },
      filesAdd: null,
      rss: ''
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    this.dataReady = false
    this.getDataList()
  },
  methods: {
    async getDataList () {
      this.dataReady = false
      // Clear Data ทุกครั้ง
      this.dataItem = []
      // Clear ช่องค้นหา
      this.searchAll = ''
      this.showTabel = false

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/broadcast/get?RECORD_STATUS=N&shopId=' +
            this.session.data.shopId
        )
        .then(async response => {
          // var dateObj = new Date(response.data.CREATE_DATE)
          // var momentObj = moment(dateObj)
          // response.data.CREATE_DATE = momentObj.format('YYYY-MM-DD')
          if (response.data.length > 0) {
            console.log('getData', response.data)
            this.dataReady = true
            this.dataItem = response.data
            this.columns = [
              { text: 'รูป', value: 'pictureUrl' },
              { text: 'กลุ่มเป้าหมาย', value: 'audiencesName' },
              { text: 'ประเภท', value: 'module' },
              { text: 'วันอัพเดท', value: 'LAST_DATE' }
            ]
          } else {
            // this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
            this.dataReady = true
          }
          // this.export_data = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
          this.dataReady = true
        })
    },
    validate (Action) {
      switch (Action) {
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async selectDB () {
      this.columns = []
      this.showTabel = false
      if (this.selectData === 'ของรางวัล') {
        this.columns = [
          { text: 'ชื่อ', value: 'name' },
          { text: 'คะแนน', value: 'point' },
          { text: 'ระดับ', value: 'levelNm' },
          { text: 'คำอธิบาย', value: 'description' },
          { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
          { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
        ]
        this.showTabel = true
        await this.getDataGlobal(
          this.DNS_IP,
          '/reward/',
          this.session.data.shopId,
          this.returnLink
        )
        this.idData = 'rewardId'
        this.path = '/reward/'
        this.dataSelectText = false
      } else if (this.selectData === 'กิจกรรม') {
        this.columns = [
          { text: 'หัวข้อ', value: 'title' },
          { text: 'ประเภท', value: 'type' },
          { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
          { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
        ]
        this.showTabel = true
        await this.getDataGlobal(
          this.DNS_IP,
          '/activity/',
          this.session.data.shopId,
          this.returnLink
        )
        this.idData = 'activityId'
        this.path = '/activity/'
        this.dataSelectText = false
      } else {
        this.dataSelect = false
        this.showTabel = true
        this.dataSelectText = true
        this.dialogSelect = false
        await this.getAudience()
      }
    },
    async getDataById (item) {
      this.dataReady = false
      this.referId = ''
      if (this.idData === 'rewardId') {
        this.referId = item.rewardId
      } else if (this.idData === 'activityId') {
        this.referId = item.activityId
      }
      await this.getDataByIdGlobal(
        this.DNS_IP,
        this.path,
        this.idData,
        this.referId,
        this.returnLink
      )
      this.dataSelect = true
      await this.getAudience()
      this.validate('UPDATE')
      console.log('Update', this.formUpdate)
    },
    async getAudience () {
      // Clear Data ทุกครั้ง
      this.dataAudience = []
      // console.log('getDataTypeGroup')
      await axios
        .get(this.DNS_IP + '/audiences/get?shopId=' + this.session.data.shopId)
        .then(async response => {
          let rs = response.data
          console.log('rss', rs)
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            // var s = {}
            d.value = d.id
            d.text = d.audiencesName
            console.log(d)
            this.dataAudience.push(d)
          }
        })
        .catch(error => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
    },
    async getMember () {
      await axios
        .get(
          this.DNS_IP +
            '/member/get?shopId=' +
            this.session.data.shopId +
            '&CONDITION_TERM2=True'
        )
        .then(res => {
          console.log('res', res)
          if (res.data.status === false) {
            this.dataMember = []
          } else {
            this.dataMember = res.data
            console.log('dataMember', this.dataMember)
          }
        })
    },
    async getDataAdd (item) {
      console.log('item', this.selectAudience)
      await axios
        .get(this.DNS_IP + '/audiences/get?shopId=' + this.session.data.shopId + '&id=' + this.selectAudience)
        .then(res => {
          this.rss = res.data
          console.log('rss', this.rss[0].ageStr)
        })
      this.valueAdd = 0
      this.dataAdd = 0
      if ((
        this.rss.audiencesLevel +
        this.rss.audiencesGender +
        this.rss.audiencesCoinStart +
        this.rss.audiencesCoinEnd +
        this.rss.audiencesExchangeRate +
        this.rss.audiencesLastUseAll +
        this.rss.ageStr +
        this.rss.ageEnd
      ).length === 0) {
      } else {
        console.log('line717')
        if (parseInt(this.rss[0].audiencesCoinStart) > parseInt(this.rss[0].audiencesCoinEnd)) {
          this.$swal(
            'ผิดพลาด',
            'ไม่สามารถกำหนดจำนวน เหรียญขั้นต่ำ ให้มากกว่าจำนวน เหรียญสูงสุด ได้',
            'error'
          )
        } else {
          if (this.rss[0].ageStr > this.rss[0].ageEnd) {
            this.$swal(
              'ผิดพลาด',
              'ไม่สามารถกำหนดจำนวน อายุเริ่มต้น ให้มากกว่าจำนวน อายุสูงสุด ได้',
              'error'
            )
          } else {
            console.log('line731')
            if (this.rss[0].audiencesLevel === undefined) {
              this.rss[0].audiencesLevel = ''
            }
            if (this.rss[0].audiencesGender === undefined) {
              this.rss[0].audiencesGender = ''
            }
            if (this.rss[0].audiencesCoinStart === undefined) {
              this.rss[0].audiencesCoinStart = 0
            }
            if (this.rss[0].audiencesCoinEnd === undefined) {
              this.rss[0].audiencesCoinEnd = 0
            }
            if (this.rss[0].audiencesExchangeRate === undefined) {
              this.rss[0].audiencesExchangeRate = ''
            } else {
              this.rss[0].audiencesExchangeRate = JSON.parse(this.rss[0].audiencesExchangeRate)
            }
            if (this.rss[0].audiencesLastUseAll === undefined) {
              this.rss[0].audiencesLastUseAll = ''
            }
            if (this.rss[0].ageStr === undefined) {
              this.rss[0].ageStr = ''
            }
            if (this.rss[0].ageEnd === undefined) {
              this.rss[0].ageEnd = ''
            }
            var body = {
              shopId: this.$session.getAll().data.shopId,
              levelId: this.rss[0].audiencesLevel,
              gender: this.rss[0].audiencesGender,
              coin: this.rss[0].audiencesCoinStart + ' ' + this.rss[0].audiencesCoinEnd,
              ageBetween: this.rss[0].ageStr + ' ' + this.rss[0].ageEnd,
              lastProductExchangeRateId: this.rss[0].audiencesExchangeRate
            }
            var shopEdit = {
              shopId: this.session.data.shopId
            }
            console.log('this.rss[0].audiencesExchangeRate', this.rss[0].audiencesExchangeRate)
            await axios
              .post(this.DNS_IP + '/member/getMember_Audience', shopEdit)
              .then(res => {
                console.log(res.data)
                this.num = res.data.length
              })
            await axios
              .post(
                this.DNS_IP + '/member/getMember_Audience', body)
              .then(res => {
                if (res.data.status === false) {
                  this.dataAdd = 0
                  this.valueAdd = 0
                } else {
                  let data = []
                  let rs = res.data
                  rs.map((val, i) =>
                    rs
                      .map(e => {
                        return e.liffUserId
                      })
                      .indexOf(val.liffUserId) === i
                      ? data.push(val)
                      : null
                  )
                  console.log('re', data)
                  this.valueAdd = parseInt(res.data.length * 100 / this.num)
                  this.dataAdd = data.length
                  console.log('memberCard2', res.data)
                  for (var x = 0; x < data.length; x++) {
                    var dt = data[x]
                    var ss = {}
                    ss.lineUserId = dt.lineUserId
                    ss.picture = dt.picture
                    ss.name = dt.name
                    this.dataUserLine.push(ss)
                  }
                }
              })
          }
        }

        // if (parseInt(this.formAdd.audiencesCoinStart) > parseInt(this.formAdd.audiencesCoinEnd)) {
        //   this.$swal(
        //     'ผิดพลาด',
        //     'ไม่สามารถกำหนดจำนวน เหรียญขั้นต่ำ ให้มากกว่าจำนวน เหรียญไม่เกิน ได้',
        //     'error'
        //   )
        //   this.formAdd.audiencesCoinStart = ''
        // }
        // if () {}
      }

      // var data = this.dataAudience.filter(el => {
      //   return el.id === this.selectAudience
      // })
      // console.log('data', data[0])
      // console.log('data', this.dataAudience)
      // var dataUse = data[0]
      // this.valueAdd = 0
      // this.dataAdd = 0
      // var num = 0
      // this.Das = this.Das = data[0].audiencesCode.substring(0, 3)
      // if (this.Das === 'Das') {
      //   await axios
      //     .get(
      //       this.DNS_IP +
      //         '/audiencesData/get?shopId=' +
      //         this.session.data.shopId +
      //         '&AudienceId=' +
      //         dataUse.audiencesCode
      //     )
      //     .then(res => {
      //       this.arr = res.data
      //       console.log('res', res.data)
      //       res.data.map(async el => {
      //         await axios
      //           .get(
      //             this.DNS_IP +
      //               '/member/getMember_Audience?shopId=' +
      //               this.session.data.shopId +
      //               '&CREATE_DATE=' +
      //               moment(String(el.Start_DATE)).format('YYYY-MM-DD') +
      //               ' ' +
      //               moment(String(el.End_DATE)).format('YYYY-MM-DD')
      //           )
      //           .then(res => {
      //             console.log('res', res)
      //             if (res.data.status === false) {
      //               this.dataMember = []
      //             } else {
      //               this.dataMember = res.data
      //               console.log('dataMember', this.dataMember)
      //             }
      //           })
      //         if (el.AudienceType === 'Branch') {
      //           await axios
      //             .get(
      //               this.DNS_IP +
      //                 '/qrcode/Audience?shopId=' +
      //                 this.session.data.shopId +
      //                 '&masBranchID=' +
      //                 dataUse.audiencesBranch +
      //                 '&LAST_DATE=' +
      //                 moment(String(el.Start_DATE)).format('YYYY-MM-DD') +
      //                 ' ' +
      //                 moment(String(el.End_DATE)).format('YYYY-MM-DD')
      //             )
      //             .then(res => {
      //               let Branch = []
      //               if (res.status === false) {
      //                 Branch = []
      //               } else {
      //                 Branch = res.data
      //                 let a = Branch.filter(
      //                   val =>
      //                     val.masBranchID.toString() ===
      //                     dataUse.audiencesBranch.toString()
      //                 )
      //                 console.log('a', a)
      //                 let serviceFilter = new Set(
      //                   a.map(({ liffUserId }) => liffUserId)
      //                 )
      //                 let memberFilter = [
      //                   ...this.dataMember.filter(({ liffUserId }) =>
      //                     serviceFilter.has(liffUserId)
      //                   )
      //                 ]
      //                 memberFilter.forEach(el => {
      //                   this.filterAudience.push(el)
      //                 })
      //               }
      //             })
      //         } else if (el.AudienceType === 'Service') {
      //           await axios
      //             .get(
      //               this.DNS_IP +
      //                 '/qrcode/Audience?shopId=' +
      //                 this.session.data.shopId +
      //                 '&productExchangeRateId=' +
      //                 dataUse.audiencesExchangeRate +
      //                 '&LAST_DATE=' +
      //                 moment(String(el.Start_DATE)).format('YYYY-MM-DD') +
      //                 ' ' +
      //                 moment(String(el.End_DATE)).format('YYYY-MM-DD')
      //             )
      //             .then(res => {
      //               let Service = []
      //               if (res.status === false) {
      //                 Service = []
      //               } else {
      //                 Service = res.data
      //                 let a = Service.filter(
      //                   val =>
      //                     val.productExchangeRateId.toString() ===
      //                     dataUse.audiencesExchangeRate.toString()
      //                 )
      //                 console.log('aS', a)
      //                 let serviceFilter = new Set(
      //                   a.map(({ liffUserId }) => liffUserId)
      //                 )
      //                 let memberFilter = [
      //                   ...this.dataMember.filter(({ liffUserId }) =>
      //                     serviceFilter.has(liffUserId)
      //                   )
      //                 ]
      //                 memberFilter.forEach(el => {
      //                   this.filterAudience.push(el)
      //                 })
      //               }
      //             })
      //         } else if (el.AudienceType === 'Level') {
      //           await axios
      //             .get(
      //               this.DNS_IP +
      //                 '/member/get?shopId=' +
      //                 this.session.data.shopId +
      //                 '&levelId=' +
      //                 dataUse.audiencesLevel +
      //                 '&LAST_DATE=' +
      //                 moment(String(el.Start_DATE)).format('YYYY-MM-DD') +
      //                 ' ' +
      //                 moment(String(el.End_DATE)).format('YYYY-MM-DD')
      //             )
      //             .then(res => {
      //               let Level = []
      //               if (res.status === false) {
      //                 Level = []
      //               } else {
      //                 Level = res.data
      //                 let a = Level.filter(
      //                   val =>
      //                     val.levelId.toString() ===
      //                     dataUse.audiencesLevel.toString()
      //                 )
      //                 console.log('aS', a)
      //                 let serviceFilter = new Set(
      //                   a.map(({ liffUserId }) => liffUserId)
      //                 )
      //                 let memberFilter = [
      //                   ...this.dataMember.filter(({ liffUserId }) =>
      //                     serviceFilter.has(liffUserId)
      //                   )
      //                 ]
      //                 memberFilter.forEach(el => {
      //                   this.filterAudience.push(el)
      //                 })
      //               }
      //             })
      //         } else if (el.AudienceType === 'Gender') {
      //           await axios
      //             .get(
      //               this.DNS_IP +
      //                 '/member/get?shopId=' +
      //                 this.session.data.shopId +
      //                 '&Gender=' +
      //                 dataUse.audiencesGender +
      //                 '&CREATE_DATE=' +
      //                 moment(String(el.Start_DATE)).format('YYYY-MM-DD') +
      //                 ' ' +
      //                 moment(String(el.End_DATE)).format('YYYY-MM-DD')
      //             )
      //             .then(res => {
      //               let Gender = []
      //               if (res.status === false) {
      //                 Gender = []
      //               } else {
      //                 Gender = res.data
      //                 let a = Gender.filter(
      //                   val => val.gender === dataUse.audiencesGender
      //                 )
      //                 console.log('aS', a)
      //                 let serviceFilter = new Set(
      //                   a.map(({ liffUserId }) => liffUserId)
      //                 )
      //                 let memberFilter = [
      //                   ...this.dataMember.filter(({ liffUserId }) =>
      //                     serviceFilter.has(liffUserId)
      //                   )
      //                 ]
      //                 memberFilter.forEach(el => {
      //                   this.filterAudience.push(el)
      //                 })
      //               }
      //             })
      //         } else if (el.AudienceType === 'Age') {
      //           await axios
      //             .get(
      //               this.DNS_IP +
      //                 '/member/get?shopId=' +
      //                 this.session.data.shopId +
      //                 '&title=' +
      //                 dataUse.audiencesAge +
      //                 '&LAST_DATE=' +
      //                 moment(String(el.Start_DATE)).format('YYYY-MM-DD') +
      //                 ' ' +
      //                 moment(String(el.End_DATE)).format('YYYY-MM-DD')
      //             )
      //             .then(res => {
      //               let Age = []
      //               if (res.status === false) {
      //                 Age = []
      //               } else {
      //                 Age = res.data
      //                 let a = Age.filter(
      //                   val => val.title === dataUse.audiencesAge
      //                 )
      //                 console.log('aS', a)
      //                 let serviceFilter = new Set(
      //                   a.map(({ liffUserId }) => liffUserId)
      //                 )
      //                 let memberFilter = [
      //                   ...this.dataMember.filter(({ liffUserId }) =>
      //                     serviceFilter.has(liffUserId)
      //                   )
      //                 ]
      //                 memberFilter.forEach(el => {
      //                   this.filterAudience.push(el)
      //                 })
      //               }
      //             })
      //         } else if (el.AudienceType === 'Page') {
      //           await axios
      //             .get(
      //               this.DNS_IP +
      //                 '/TransactionVisitPage/get?shopId=' +
      //                 this.session.data.shopId +
      //                 '&page=' +
      //                 dataUse.audiencesVisit +
      //                 '&CREATE_DATE=' +
      //                 moment(String(el.Start_DATE)).format('YYYY-MM-DD') +
      //                 ' ' +
      //                 moment(String(el.End_DATE)).format('YYYY-MM-DD')
      //             )
      //             .then(res => {
      //               let Page = []
      //               if (res.status === false) {
      //                 Page = []
      //               } else {
      //                 Page = res.data
      //                 let a = Page.filter(
      //                   val => val.page === dataUse.audiencesVisit
      //                 )
      //                 console.log('aS', a)
      //                 let serviceFilter = new Set(
      //                   a.map(({ CREATE_USER }) => CREATE_USER)
      //                 )
      //                 let memberFilter = [
      //                   ...this.dataMember.filter(({ liffUserId }) =>
      //                     serviceFilter.has(liffUserId)
      //                   )
      //                 ]
      //                 memberFilter.forEach(el => {
      //                   this.filterAudience.push(el)
      //                 })
      //               }
      //             })
      //         } else {
      //           await axios
      //             .get(
      //               this.DNS_IP +
      //                 '/TransactionVisitPage/get?shopId=' +
      //                 this.session.data.shopId +
      //                 '&rewardId=' +
      //                 dataUse.audiencesReward +
      //                 '&CREATE_DATE=' +
      //                 moment(String(el.Start_DATE)).format('YYYY-MM-DD') +
      //                 ' ' +
      //                 moment(String(el.End_DATE)).format('YYYY-MM-DD')
      //             )
      //             .then(res => {
      //               let rewardId = []
      //               if (res.status === false) {
      //                 rewardId = []
      //               } else {
      //                 rewardId = res.data
      //                 let a = rewardId.filter(
      //                   val => val.rewardId === dataUse.audiencesReward
      //                 )
      //                 console.log('aS', a)
      //                 let serviceFilter = new Set(
      //                   a.map(({ CREATE_USER }) => CREATE_USER)
      //                 )
      //                 let memberFilter = [
      //                   ...this.dataMember.filter(({ liffUserId }) =>
      //                     serviceFilter.has(liffUserId)
      //                   )
      //                 ]
      //                 memberFilter.forEach(el => {
      //                   this.filterAudience.push(el)
      //                 })
      //               }
      //             })
      //         }
      //         console.log('this.filterAudience', this.filterAudience)
      //         let val = this.filterAudience.map(item => {
      //           return item.liffUserId
      //         })
      //         console.log('fil', val)
      //         this.dupCounts(val)
      //         console.log('counts', this.dupCounts(val))
      //         let idLiffuser = Object.keys(this.dupCounts(val))
      //         console.log('idLiffuser', idLiffuser)
      //         let dd = idLiffuser
      //           .map(item =>
      //             this.dataMember.filter(item2 => item2.liffUserId === item)
      //           )
      //           .flat()
      //         console.log('dd', dd)
      //         this.dataUserLine = []
      //         dd.map(el => {
      //           console.log('el', el)
      //           this.dataUserLine.push(el)
      //           console.log(this.dataUserLine)
      //         })
      //       })
      //     })
      // } else {
      //   await axios
      //     .get(
      //       this.DNS_IP +
      //         '/member/getMember_Audience?shopId=' +
      //         this.session.data.shopId
      //     )
      //     .then(async response => {
      //       if (response.data.status === false) {
      //         this.valueAdd = 0
      //         this.dataAdd = 0
      //       } else {
      //         num = response.data.length
      //         this.valueAdd = 100
      //         this.dataAdd = num
      //         if (dataUse.audiencesLastUseAll === 0) {
      //           dataUse.audiencesLastUseAll = ''
      //         }
      //         var url = ''
      //         if (
      //           (
      //             dataUse.audiencesLevel +
      //             dataUse.audiencesGender +
      //             dataUse.audiencesCoinStart +
      //             dataUse.audiencesCoinEnd +
      //             dataUse.audiencesExchangeRate +
      //             dataUse.audiencesLastUseAll +
      //             dataUse.audiencesBranch +
      //             dataUse.audiencesVisit +
      //             dataUse.audiencesReward
      //           ).length === 0
      //         ) {
      //           this.valueAdd = 100
      //           this.dataAdd = num
      //         } else if (
      //           dataUse.audiencesBranch === 0 &&
      //           dataUse.audiencesGender === 0 &&
      //           dataUse.audiencesCoinStart === 0 &&
      //           dataUse.audiencesCoinEnd === 0 &&
      //           dataUse.audiencesLastUseAll === 0 &&
      //           this.formUpdate.audiencesExchangeRate === 0 &&
      //           dataUse.audiencesVisit === 0 &&
      //           dataUse.audiencesReward === 0
      //         ) {
      //           if (dataUse.audiencesLevel === 'allLevel') {
      //             url =
      //               this.DNS_IP +
      //               '/member/getMember_Audience?shopId=' +
      //               this.session.data.shopId
      //           } else {
      //             url =
      //               this.DNS_IP +
      //               '/member/getMember_Audience?shopId=' +
      //               this.session.data.shopId +
      //               '&levelId=' +
      //               dataUse.audiencesLevel
      //           }
      //         } else {
      //           if (dataUse.audiencesLastUseAll === null || '0') {
      //             dataUse.audiencesLastUseAll = ''
      //           }
      //           if (dataUse.audiencesVisit === null) {
      //             dataUse.audiencesVisit = ''
      //           }
      //           if (dataUse.audiencesReward === null) {
      //             dataUse.audiencesReward = ''
      //           }
      //           if (dataUse.audiencesBranch === null) {
      //             dataUse.audiencesBranch = ''
      //           }
      //           if (dataUse.audiencesBranch === null) {
      //             dataUse.audiencesBranch = ''
      //           }
      //           if (
      //             parseInt(dataUse.audiencesCoinStart || '0') +
      //               parseInt(dataUse.audiencesCoinEnd || '0') >
      //             0
      //           ) {
      //             if (
      //               parseInt(dataUse.audiencesCoinStart || '0') <
      //               parseInt(dataUse.audiencesCoinEnd || '0')
      //             ) {
      //               if (dataUse.audiencesLevel === 'allLevel') {
      //                 url =
      //                   this.DNS_IP +
      //                   '/member/getMember_Audience?shopId=' +
      //                   this.session.data.shopId +
      //                   '&levelId=' +
      //                   dataUse.audiencesLevel +
      //                   '&coin=' +
      //                   dataUse.audiencesCoinStart +
      //                   ' ' +
      //                   dataUse.audiencesCoinEnd +
      //                   '&lastProductExchangeRateId=' +
      //                   dataUse.audiencesExchangeRate +
      //                   '&gender=' +
      //                   dataUse.audiencesGender +
      //                   '&branch=' +
      //                   dataUse.audiencesBranch +
      //                   '&page=' +
      //                   dataUse.audiencesVisit +
      //                   '&reward=' +
      //                   dataUse.audiencesReward
      //               } else {
      //                 url =
      //                   this.DNS_IP +
      //                   '/member/getMember_Audience?shopId=' +
      //                   this.session.data.shopId +
      //                   '&levelId=' +
      //                   dataUse.audiencesLevel +
      //                   '&coin=' +
      //                   dataUse.audiencesCoinStart +
      //                   ' ' +
      //                   dataUse.audiencesCoinEnd +
      //                   '&lastUes=' +
      //                   dataUse.audiencesLastUseAll +
      //                   '&lastProductExchangeRateId=' +
      //                   dataUse.audiencesExchangeRate +
      //                   '&gender=' +
      //                   dataUse.audiencesGender +
      //                   '&branch=' +
      //                   dataUse.audiencesBranch +
      //                   '&page=' +
      //                   dataUse.audiencesVisit +
      //                   '&reward=' +
      //                   dataUse.audiencesReward
      //               }
      //             } else {
      //               if (dataUse.audiencesLevel === 'allLevel') {
      //                 this.$swal(
      //                   'ผิดพลาด',
      //                   'กรุณาตั้ง Coin ไม่เกิน ให้มากกว่า Coin ขั้นต่ำ',
      //                   'error'
      //                 )
      //                 url =
      //                   this.DNS_IP +
      //                   '/member/getMember_Audience?shopId=' +
      //                   this.session.data.shopId +
      //                   '&lastUes=' +
      //                   dataUse.audiencesLastUseAll +
      //                   '&lastProductExchangeRateId=' +
      //                   dataUse.audiencesExchangeRate +
      //                   '&gender=' +
      //                   dataUse.audiencesGender +
      //                   '&branch=' +
      //                   dataUse.audiencesBranch +
      //                   '&page=' +
      //                   dataUse.audiencesVisit +
      //                   '&reward=' +
      //                   dataUse.audiencesReward
      //               } else {
      //                 this.$swal(
      //                   'ผิดพลาด',
      //                   'กรุณาตั้ง Coin ไม่เกิน ให้มากกว่า Coin ขั้นต่ำ',
      //                   'error'
      //                 )
      //                 url =
      //                   this.DNS_IP +
      //                   '/member/getMember_Audience?shopId=' +
      //                   this.session.data.shopId +
      //                   '&levelId=' +
      //                   dataUse.audiencesLevel +
      //                   '&lastUes=' +
      //                   dataUse.audiencesLastUseAll +
      //                   '&lastProductExchangeRateId=' +
      //                   dataUse.audiencesExchangeRate +
      //                   '&gender=' +
      //                   dataUse.audiencesGender +
      //                   '&branch=' +
      //                   dataUse.audiencesBranch +
      //                   '&page=' +
      //                   dataUse.audiencesVisit +
      //                   '&reward=' +
      //                   dataUse.audiencesReward
      //               }
      //             }
      //           } else {
      //             if (dataUse.audiencesLevel === 'allLevel') {
      //               url =
      //                 this.DNS_IP +
      //                 '/member/getMember_Audience?shopId=' +
      //                 this.session.data.shopId +
      //                 '&lastUes=' +
      //                 dataUse.audiencesLastUseAll +
      //                 '&lastProductExchangeRateId=' +
      //                 dataUse.audiencesExchangeRate +
      //                 '&gender=' +
      //                 dataUse.audiencesGender +
      //                 '&branch=' +
      //                 dataUse.audiencesBranch +
      //                 '&page=' +
      //                 dataUse.audiencesVisit +
      //                 '&reward=' +
      //                 dataUse.audiencesReward
      //             } else {
      //               url =
      //                 this.DNS_IP +
      //                 '/member/getMember_Audience?shopId=' +
      //                 this.session.data.shopId +
      //                 '&levelId=' +
      //                 dataUse.audiencesLevel +
      //                 '&lastUes=' +
      //                 dataUse.audiencesLastUseAll +
      //                 '&lastProductExchangeRateId=' +
      //                 dataUse.audiencesExchangeRate +
      //                 '&gender=' +
      //                 dataUse.audiencesGender +
      //                 '&branch=' +
      //                 dataUse.audiencesBranch +
      //                 '&page=' +
      //                 dataUse.audiencesVisit +
      //                 '&reward=' +
      //                 dataUse.audiencesReward
      //             }
      //           }
      //           await axios.get(url).then(async res => {
      //             console.log('asas', res.data)
      //             console.log('asas', url)
      //             this.dataUserLine = []
      //             if (res.data.status === false) {
      //               this.valueAdd = parseInt((0 / num) * 100)
      //               this.dataAdd = 0
      //               for (var i = 0; i < num; i++) {
      //                 var d = response.data[i]
      //                 var s = {}
      //                 s.lineUserId = d.lineUserId
      //                 s.picture = d.picture
      //                 s.name = d.name
      //                 this.dataUserLine.push(s)
      //               }
      //             } else {
      //               let data = []
      //               let rs = res.data
      //               rs.map((val, i) =>
      //                 rs
      //                   .map(e => {
      //                     return e.liffUserId
      //                   })
      //                   .indexOf(val.liffUserId) === i
      //                   ? data.push(val)
      //                   : null
      //               )
      //               console.log('re', data)
      //               this.valueAdd = parseInt((data.length / num) * 100)
      //               this.dataAdd = data.length
      //               console.log('memberCard2', res.data)
      //               for (var x = 0; x < data.length; x++) {
      //                 var dt = data[x]
      //                 var ss = {}
      //                 ss.lineUserId = dt.lineUserId
      //                 ss.picture = dt.picture
      //                 ss.name = dt.name
      //                 this.dataUserLine.push(ss)
      //               }
      //             }
      //           })
      //         }
      //       }
      //     })
      // }
    },
    dupCounts (val) {
      var counts = {}
      val.forEach(function (n) {
        counts[n] = counts[n] || 0
        counts[n]++
      })
      for (var key in counts) {
        console.log('this.arr.length', this.arr.length)
        if (counts[key] < this.arr.length) {
          delete counts[key]
        }
      }
      return counts
    },
    async sendPush () {
      this.$swal({
        title: 'ต้องการ แจ้งเตือน ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(async result => {
        this.loadingAdd = true
        var modules = ''
        if (this.idData === 'rewardId') {
          modules = 'ของรางวัล'
        } else if (this.idData === 'activityId') {
          modules = 'กิจกรรม'
        } else {
          modules = 'text'
        }
        var data = {}
        if (modules === 'text') {
          const _this = this
          let params = new FormData()
          params.append('file', this.filesAdd)

          await axios
            .post(this.DNS_IP + `/file/upload/blog`, params)
            .then(function (response) {
              _this.formAdd.pictureUrl = response.data
              console.log('url Pic', response.data)
            })
          data = {
            shopId: this.session.data.shopId,
            audiencesId: this.selectAudience,
            module: modules,
            referId: 'text',
            pictureUrl: this.formAdd.pictureUrl,
            topic: this.formAdd.topic,
            message: this.formAdd.content,
            endDateStr: this.formUpdate.endDateStr,
            lineUserId: this.dataUserLine,
            CREATE_USER: this.session.data.userName,
            LAST_USER: this.session.data.userName
          }
        } else if (modules === 'กิจกรรม') {
          data = {
            shopId: this.session.data.shopId,
            audiencesId: this.selectAudience,
            module: modules,
            referId: this.referId,
            pictureUrl: this.formUpdate.pictureUrl,
            topic: this.formUpdate.titleText,
            message: this.formUpdate.title,
            subName: this.formUpdate.subName,
            point: this.formUpdate.point,
            coin: this.formUpdate.coin,
            endDateStr: this.formUpdate.endDateStr.replace(/-/g, '/'),
            lineUserId: this.dataUserLine,
            CREATE_USER: this.session.data.userName,
            LAST_USER: this.session.data.userName
          }
        } else {
          data = {
            shopId: this.session.data.shopId,
            audiencesId: this.selectAudience,
            module: modules,
            referId: this.referId,
            pictureUrl: this.formUpdate.pictureUrl,
            topic: this.formUpdate.titleText,
            message: this.formUpdate.title,
            subName: this.formUpdate.subName,
            point: this.formUpdate.point,
            coin: this.formUpdate.coin,
            lineUserId: this.dataUserLine,
            CREATE_USER: this.session.data.userName,
            LAST_USER: this.session.data.userName
          }
        }
        console.log('data', data)
        await axios
          .post(this.DNS_IP + '/broadcast/add', data)
          .then(async response => {
            console.log('addDataGlobal DNS_IP + PATH + "add"', response)
            this.dataSelect = false
            this.dataSelectText = false
            this.formUpdate = {}
            this.formAdd = {}
            this.dataUserLine = []
            this.referId = ''
            this.selectAudience = ''
            this.valueAdd = 0
            this.dataAdd = 0
            this.dataAudience = []
            this.dataUserLine = []
            this.dataItem = []
            this.filesAdd = null
            this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
            this.loadingAdd = false
            this.getDataList()
          })
      })
    },
    selectImg () {
      if (this.filesAdd) {
        this.formAdd.pictureUrl = URL.createObjectURL(this.filesAdd)
        console.log(this.formAdd.pictureUrl)
      } else {
        this.formAdd.pictureUrl = ''
      }
      // console.log(event)
    },
    clearData () {
      this.selectData = ''
      this.showTabel = true
    }
    // clearDataBroadcast () {
    //   this.selectAudience = ''
    // }
    // tabel () {
    //   this.showTabel = false
    // }
  }
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/BroadCast/BroadCast.vue